import { useEffect, useMemo } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
// import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';
import UniversalRecordTable from '../../components/Tables/universalRecord/UniversalRecordTable';
import { printerColumns } from '../../features/printer/printerColumns';
import usePrinter from '../../hooks/hardware/usePrinter';
import PrinterRegistrationPopup from '../../components/hardware/printer/PrinterRegistrationPopup';
import PrinterEditPopup from '../../components/hardware/printer/PrinterEditPopup';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const TicketPrinter = () => {
  const {
    list,
    form,
    showRegistrationModal,
    showEditModal,
    openRegistrationModal,
    closeRegistrationModal,
    fetchPrinterById,
    savePrinter,
    toggleStatus,
    fetchAllPrinters,
  } = usePrinter();

  useEffect(() => {
    fetchAllPrinters(); // 🚀 Cargar impresoras al montar
  }, []);

  const columns = useMemo(() => printerColumns, []);

  const getActions = (row: any) => [
    {
      key: 'edit',
      label: 'Editar',
      onClick: () => fetchPrinterById(row.id),
    },
    {
      key: 'deactivate',
      label: 'Activar/Desactivar',
      onClick: () => toggleStatus(row.id),
    },
  ];

  return (
    <DefaultLayout>
      {/* <Breadcrumb pageName="Impresoras Térmicas" /> */}
      <BreadcrumbTwo />


      <UniversalRecordTable
        columns={columns}
        data={list}
        getActions={getActions}
        showPagination={false}
        enableRowClick={true}
        onPageChange={() => {}}
        onPageSizeChange={() => {}}
        noDataMessage="No hay impresoras registradas."
        topRightAction={{
          label: 'Nueva Impresora',
          onClick: openRegistrationModal,
        }}
      />

      <PrinterRegistrationPopup
        isOpen={showRegistrationModal}
        onClose={closeRegistrationModal}
        onSave={() => savePrinter(form)}
      />

      <PrinterEditPopup
        isOpen={showEditModal}
        onUpdate={() => savePrinter(form)}
      />
    </DefaultLayout>
  );
};

export default TicketPrinter;
